import { StreamActions } from "@hotwired/turbo"

StreamActions.alert = function () {
  console.log(this);
  alert(this.getAttribute("text"));
}
